const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const normalizeWheel = require("normalize-wheel");

const {shallowEqOnKeys} = require("../util/SCUUtil");
const ErrorUtil = require("../../../shared/ErrorUtil");
const ScrollBar = require("./ScrollBar");
const ScrollContent = require("./ScrollContent");

const CONSECUTIVE_RENDER_LIMIT = 10;

const defaultMainTheme = require("./styles/ScrollAreaDefault.css");
const defaultFadeTheme = require("./styles/ScrollFadeDefault.css");

// Terms used for the DOM elements this component renders. Also the names of
// classes in the main theme prop.
// - area: the wrapper div around everything, named after the component
// - pos: wrapper div around content that has scroll position styling applied
//   to it. For animated scrolling, apply transition: transform here.
// - content: wrapper div around the children passed by calling code
// - xBar: the wide, short div that the horizontal thumb lives in
// - xThumb: the nub in the xBar that the user can drag around to scroll
// - yBar: the tall, narrow div that the vertical thumb lives in
// - yThumb: the nub in the yBar that the user can drag around to scroll
// - preventOuterScroll: prevent scroll outside scroll area

// In the component state, (xPos, yPos) is the position relative to the content
// of the top left corner of the visible area. In particular, both are
// nonnegative when inbounds.

module.exports = createReactClass({
	displayName: "ScrollArea",

	// All required props have defaults. Passing no props gets a scrollthumb in both
	// directions (thumbs only visible if content overflows) with default styling.
	propTypes: {
		// Basic/misc props

		hasXScroll: PT.bool.isRequired,
		hasYScroll: PT.bool.isRequired,
		initialXPos: PT.number,
		initialYPos: PT.number,
		children: PT.node,
		isFrozen: PT.bool,

		useGlobalHotkeysForX: PT.bool,
		useGlobalHotkeysForY: PT.bool,
		onKeySpecial: PT.func,
		useMouseMoveToScroll: PT.bool,
		useWonkyCursor: PT.bool,

		preservePosRatio: PT.bool,
		scrollSpeed: PT.number.isRequired,
		preventOuterScroll: PT.bool, //Prevent default on scroll wheel, so entire page doesn't scroll

		xBarGateway: PT.string,
		yBarGateway: PT.string,

		minXThumbSize: PT.number,
		minYThumbSize: PT.number,

		onScrollX: PT.func,
		onScrollY: PT.func,

		disableDragScroll: PT.bool,
		hideScrollbar: PT.bool,

		// Main CSS module. Default provided; if you just need a few extras, you
		// can use the className and style props below.

		mainTheme: PT.shape({
			area: PT.string,
			pos: PT.string,
			content: PT.string,
			xBar: PT.string,
			xThumb: PT.string,
			yBar: PT.string,
			yThumb: PT.string,
		}).isRequired,

		// Optional manual styling, applied in addition to theme prop.

		areaClassName: PT.string,
		areaStyle: PT.object,
		posClassName: PT.string,
		posStyle: PT.object,
		contentClassName: PT.string,
		contentStyle: PT.object,
		xBarClassName: PT.string,
		xBarStyle: PT.object,
		xBarSize: PT.number,
		xThumbClassName: PT.string,
		xThumbStyle: PT.object,
		yBarClassName: PT.string,
		yBarStyle: PT.object,
		yBarSize: PT.number,
		yThumbClassName: PT.string,
		yThumbStyle: PT.object,

		// Fade props. The provided defaults make a white gradient fade on edges.

		// If true, turn off fade. All other fade properties do nothing.
		noFade: PT.bool,
		// Extra pixels given to fade to fix browser rounding failures. Should
		// match corresponding values in CSS module; see default css for example.
		fadeSizeNudge: PT.number.isRequired,
		// Fade size maximum as a coefficient on area size along the scroll
		// dimension. Set to Infinity to disable.
		fadeSizeMaxCoeff: PT.number.isRequired,
		// Fade size maximum as an absolute number. Set to Infinity to disable.
		fadeSizeMaxAbs: PT.number.isRequired,

		// CSS module
		fadeTheme: PT.shape({
			top: PT.string,
			bottom: PT.string,
			left: PT.string,
			right: PT.string,
		}).isRequired,
	},

	// Lifecycle

	getDefaultProps: function() {
		return {
			hasXScroll: true,
			hasYScroll: true,
			scrollSpeed: 1,
			mainTheme: defaultMainTheme,
			fadeSizeNudge: 2,
			fadeSizeMaxCoeff: 0.05,
			fadeSizeMaxAbs: 20,
			fadeTheme: defaultFadeTheme,
			onKeySpecial: () => {},
		};
	},

	getInitialState: function() {
		return {
			reloadInitialPos: true,
			areaWidth: 1,
			areaHeight: 1,
			contentWidth: 1,
			contentHeight: 1,
			xPos: this.props.initialXPos || 0,
			yPos: this.props.initialYPos || 0,
			isDragging: false,
			hasDragged: false, // whether a visible drag actually happened during the last drag event
			isFrozen: false,
		};
	},

	UNSAFE_componentWillReceiveProps: function(nextProps) {
		const options = {keepReloading: true};
		if (this.state.reloadInitialPos) {
			this.scrollToX(nextProps.initialXPos || 0, options);
			this.scrollToY(nextProps.initialYPos || 0, options);
		} else {
			if (nextProps.initialXPos !== this.props.initialXPos) {
				this.scrollToX(nextProps.initialXPos || 0, options);
			}
			if (nextProps.initialYPos !== this.props.initialYPos) {
				this.scrollToY(nextProps.initialYPos || 0, options);
			}
		}
	},

	componentDidMount: function() {
		window.addEventListener("resize", this.handleWindowResize);
		this.contentDiv.addEventListener("wheel", this.handleMouseWheel);
		this.contentDiv.addEventListener("touchstart", this.handleTouchStart);
		this.contentDiv.addEventListener("touchmove", this.handleTouchMove);
		if (this.props.useMouseMoveToScroll) {
			this.contentDiv.addEventListener("mousedown", this.handleGlobalMouseDown);
			this.contentDiv.addEventListener("mousemove", this.handleGlobalMouseMove);
			document.addEventListener("mouseup", this.handleGlobalMouseRelease);
		}
		this.updateSizes();
	},

	componentDidUpdate: function() {
		this.consecutiveRenders = (this.consecutiveRenders || 0) + 1;
		if (this.consecutiveRenders >= CONSECUTIVE_RENDER_LIMIT) {
			// Tough to provide useful info about which scroll area is causing
			// issues, but here's an attempt.
			const logProps = _.pickBy(
				_.pick(this.props, [
					"mainTheme",
					"areaClassName",
					"areaStyle",
					"posClassName",
					"posStyle",
					"contentClassName",
					"contentStyle",
					"xBarClassName",
					"xBarStyle",
					"xThumbClassName",
					"xThumbStyle",
					"yBarClassName",
					"yBarStyle",
					"yThumbClassName",
					"yThumbStyle",
				]),
				Boolean
			);
			ErrorUtil.log(
				"E_SCROLLAREA_COMP_LOOP",
				"More than " +
					this.consecutiveRenders +
					" renders in a row trying to update sizes " +
					"of a ScrollArea. Terminating.",
				{props: logProps}
			);
			return;
		}

		const updated = this.updateSizes();
		if (!updated) {
			this.consecutiveRenders = 0;
		}
	},

	componentWillUnmount: function() {
		window.removeEventListener("resize", this.handleWindowResize);
		this.contentDiv.removeEventListener("wheel", this.handleMouseWheel);
		this.contentDiv.removeEventListener("touchstart", this.handleTouchStart);
		this.contentDiv.removeEventListener("touchmove", this.handleTouchMove);
		if (this.props.useMouseMoveToScroll) {
			this.contentDiv.removeEventListener(
				"mousedown",
				this.handleGlobalMouseDown
			);
			this.contentDiv.removeEventListener(
				"mousemove",
				this.handleGlobalMouseMove
			);
			document.removeEventListener("mouseup", this.handleGlobalMouseRelease);
			if (this.handleGlobalMouseReleaseTimeout) {
				clearTimeout(this.handleGlobalMouseReleaseTimeout);
			}
		}
	},

	// Internal helpers

	canScrollX: function() {
		if (!this.props.hasXScroll) {
			return false;
		}
		const {areaWidth, contentWidth} = this.state;
		return contentWidth > areaWidth;
	},

	canScrollY: function() {
		if (!this.props.hasYScroll) {
			return false;
		}
		const {areaHeight, contentHeight} = this.state;

		return contentHeight > areaHeight;
	},

	distanceToLeftEdge: function(pos = this.state.xPos) {
		return Math.max(pos, 0);
	},

	distanceToRightEdge: function(pos = this.state.xPos, sizes = this.state) {
		const {areaWidth, contentWidth} = sizes;
		return Math.max(contentWidth - areaWidth - pos, 0);
	},

	distanceToTopEdge: function(pos = this.state.yPos) {
		return Math.max(pos, 0);
	},

	distanceToBottomEdge: function(pos = this.state.yPos, sizes = this.state) {
		const {areaHeight, contentHeight} = sizes;
		return Math.max(contentHeight - areaHeight - pos, 0);
	},

	clampXPos: function(pos, sizes = this.state) {
		const {areaWidth, contentWidth} = sizes;
		return Math.max(0, Math.min(contentWidth - areaWidth, pos));
	},

	clampYPos: function(pos, sizes = this.state) {
		const {areaHeight, contentHeight} = sizes;
		return Math.max(0, Math.min(contentHeight - areaHeight, pos));
	},

	preserveXRatio: function(pos, oldSizes, newSizes) {
		if (oldSizes.contentWidth <= oldSizes.areaWidth) {
			return 0;
		}
		const t = pos / (oldSizes.contentWidth - oldSizes.areaWidth);
		return t * (newSizes.contentWidth - newSizes.areaWidth);
	},

	preserveYRatio: function(pos, oldSizes, newSizes) {
		if (oldSizes.contentHeight <= oldSizes.areaHeight) {
			return 0;
		}
		const t = pos / (oldSizes.contentHeight - oldSizes.areaHeight);
		return t * (newSizes.contentHeight - newSizes.areaHeight);
	},

	computeSizes: function() {
		if (!this.areaDiv || !this.contentDiv) {
			return null;
		}
		return {
			areaWidth: Math.max(this.areaDiv.offsetWidth, 1),
			areaHeight: Math.max(this.areaDiv.offsetHeight, 1),
			contentWidth: Math.max(this.contentDiv.offsetWidth, 1),
			contentHeight: Math.max(this.contentDiv.offsetHeight, 1),
		};
	},

	// Returns whether a setState call occurred.
	setPosByDelta: function(xDelta, yDelta, options = {}) {
		const {forceScroll = false} = options;
		// Don't scroll if scroll area is frozen
		if (this.props.isFrozen && !forceScroll) return false;

		xDelta = this.props.hasXScroll ? +xDelta || 0 : 0;
		yDelta = this.props.hasYScroll ? +yDelta || 0 : 0;
		const newXPos = this.clampXPos(this.state.xPos + xDelta);
		const newYPos = this.clampYPos(this.state.yPos + yDelta);

		if (newXPos !== this.state.xPos || newYPos !== this.state.yPos) {
			if (newXPos !== this.state.xPos) {
				this.props.onScrollX && this.props.onScrollX(newXPos);
			}
			if (newYPos !== this.state.yPos) {
				this.props.onScrollY && this.props.onScrollY(newYPos);
			}
			this.setState({xPos: newXPos, yPos: newYPos, reloadInitialPos: false});
			return true;
		}
		return false;
	},

	// Public methods intended to be used by refs

	scrollToX: function(xPos, options = {}) {
		const {force = false, keepReloading = false} = options;
		if (this.props.hasXScroll) {
			xPos = force ? xPos : this.clampXPos(xPos);
			if (xPos !== this.state.xPos) {
				this.props.onScrollX && this.props.onScrollX(xPos);
				this.setState({
					xPos,
					reloadInitialPos: this.state.reloadInitialPos && keepReloading,
				});
			}
		}
	},

	scrollToY: function(yPos, options = {}) {
		const {force = false, keepReloading = false} = options;
		if (this.props.hasYScroll) {
			yPos = force ? yPos : this.clampYPos(yPos);
			if (yPos !== this.state.yPos) {
				this.props.onScrollY && this.props.onScrollY(yPos);
				this.setState({
					yPos,
					reloadInitialPos: this.state.reloadInitialPos && keepReloading,
				});
			}
		}
	},

	scrollToLeft: function() {
		this.scrollToX(0);
	},

	scrollToRight: function() {
		this.scrollToX(Infinity); // Gets clamped.
	},

	scrollToTop: function() {
		this.scrollToY(0);
	},

	scrollToBottom: function() {
		this.scrollToY(Infinity); // Gets clamped.
	},

	getScrollPos: function() {
		return [this.state.xPos, this.state.yPos];
	},

	// Called by outside function
	getContentHeight: function() {
		return this.state.contentHeight;
	},

	// Use case for outside code calling is if the children can change size
	// without this component realizing.
	updateSizes: function() {
		const newSizes = this.computeSizes();
		if (
			newSizes &&
			!shallowEqOnKeys(newSizes, this.state, Object.keys(newSizes))
		) {
			let {xPos, yPos} = this.state;
			if (this.props.preservePosRatio) {
				xPos = this.preserveXRatio(xPos, this.state, newSizes);
				yPos = this.preserveYRatio(yPos, this.state, newSizes);
			}
			if (
				this.state.reloadInitialPos &&
				typeof this.props.initialXPos === "number"
			) {
				xPos = this.props.initialXPos;
			}
			if (
				this.state.reloadInitialPos &&
				typeof this.props.initialYPos === "number"
			) {
				yPos = this.props.initialYPos;
			}
			newSizes.xPos = this.clampXPos(xPos, newSizes);
			newSizes.yPos = this.clampYPos(yPos, newSizes);
			this.setState(newSizes);
			return true;
		}
		return false;
	},

	// Event handlers

	handleTouchStart: function(e) {
		const touches = e.changedTouches;
		if (touches.length === 1) {
			this.lastTouchX = touches[0].pageX;
			this.lastTouchY = touches[0].pageY;
		}
	},

	handleTouchMove: function(e) {
		e.preventDefault();
		if (this.props.disableDragScroll) {
			return;
		}
		const touches = e.changedTouches;
		if (touches.length === 1) {
			const clientX = touches[0].pageX;
			const clientY = touches[0].pageY;
			const deltaX = this.lastTouchX - clientX;
			const deltaY = this.lastTouchY - clientY;
			this.lastTouchX = clientX;
			this.lastTouchY = clientY;
			this.setPosByDelta(deltaX, deltaY);
		}
	},

	handleGlobalMouseDown: function(e) {
		this.lastMouseX = e.clientX;
		this.lastMouseY = e.clientY;
		this.setState({isDragging: true});
	},

	handleGlobalMouseMove: function(e) {
		if (!this.state.isDragging) {
			return;
		}
		const deltaX = this.lastMouseX - e.clientX;
		const deltaY = this.lastMouseY - e.clientY;
		this.lastMouseX = e.clientX;
		this.lastMouseY = e.clientY;
		const didDrag = this.setPosByDelta(deltaX, deltaY);
		if (didDrag) {
			this.setState({hasDragged: true});
		}
	},

	handleGlobalMouseRelease: function() {
		this.setState({isDragging: false});
		this.handleGlobalMouseReleaseTimeout = setTimeout(() => {
			// setTimeout hack to allow other events to check if this was dragged first
			this.setState({hasDragged: false});
		}, 0);
	},

	handleBarChange: function(deltaX, deltaY) {
		this.setPosByDelta(deltaX, deltaY);
	},

	handleMouseWheel: function(e) {
		const normalized = normalizeWheel(e);
		const deltaX = normalized.pixelX * this.props.scrollSpeed * 0.8;
		const deltaY = normalized.pixelY * this.props.scrollSpeed * 0.8;
		const didScroll = this.setPosByDelta(deltaX, deltaY, {forceScroll: true});
		if (didScroll || this.props.preventOuterScroll) {
			e.preventDefault();
		}
	},

	handleWindowResize: function() {
		this.updateSizes();
	},

	// Rendering

	// Pass one of area, content, xBar, xThumb, yBar, yThumb.
	makeClassName: function(partName) {
		let className = this.props.mainTheme[partName];
		if (this.props[partName + "ClassName"]) {
			className += " " + this.props[partName + "ClassName"];
		}
		return className;
	},

	// dir is -1 (left) or 1 (right)
	renderFadeX: function(dir) {
		if (!this.canScrollX()) {
			return null;
		}
		const {
			fadeSizeNudge,
			fadeSizeMaxAbs,
			fadeSizeMaxCoeff,
			fadeTheme,
		} = this.props;
		const dist =
			dir > 0 ? this.distanceToRightEdge() : this.distanceToLeftEdge();
		const key = dir > 0 ? "right" : "left";
		const style = {
			width:
				fadeSizeNudge +
				Math.min(
					this.state.contentWidth * fadeSizeMaxCoeff,
					fadeSizeMaxAbs,
					dist
				),
			visibility: dist > 0 ? "visible" : "hidden",
		};
		return <div key={key} className={fadeTheme[key]} style={style} />;
	},

	// dir is -1 (top) or 1 (bottom)
	renderFadeY: function(dir) {
		if (!this.canScrollY()) {
			return null;
		}
		const {
			fadeSizeNudge,
			fadeSizeMaxAbs,
			fadeSizeMaxCoeff,
			fadeTheme,
		} = this.props;
		const dist =
			dir > 0 ? this.distanceToBottomEdge() : this.distanceToTopEdge();
		const key = dir > 0 ? "bottom" : "top";
		const style = {
			height:
				fadeSizeNudge +
				Math.min(
					this.state.contentHeight * fadeSizeMaxCoeff,
					fadeSizeMaxAbs,
					dist
				),
			visibility: dist > 0 ? "visible" : "hidden",
		};
		return <div key={key} className={fadeTheme[key]} style={style} />;
	},

	render: function() {
		const {hideScrollbar} = this.props;
		const cursorStyle = {
			cursor: this.props.useWonkyCursor
				? "url(/assets/images/cursors/wonky-hand-point.cur), pointer"
				: "pointer",
		};
		const scrollbarX =
			this.canScrollX() && !hideScrollbar ? (
				<ScrollBar
					axis="x"
					areaSize={this.state.areaWidth}
					contentSize={this.state.contentWidth}
					contentPos={this.state.xPos}
					barClassName={this.makeClassName("xBar")}
					barSize={this.props.xBarSize}
					barStyle={_.extend(this.props.xBarStyle, cursorStyle)}
					thumbClassName={this.makeClassName("xThumb")}
					thumbStyle={_.extend(this.props.xThumbStyle, cursorStyle)}
					minThumbSize={this.props.minXThumbSize}
					useGlobalHotkeys={this.props.useGlobalHotkeysForX}
					onChange={delta => this.handleBarChange(delta, 0)}
					onKeySpecial={code => this.props.onKeySpecial("x", code)}
				/>
			) : null;

		const scrollbarY =
			this.canScrollY() && !hideScrollbar ? (
				<ScrollBar
					axis="y"
					areaSize={this.state.areaHeight}
					contentSize={this.state.contentHeight}
					contentPos={this.state.yPos}
					barClassName={this.makeClassName("yBar")}
					barSize={this.props.yBarSize}
					barStyle={_.extend(this.props.yBarStyle, cursorStyle)}
					thumbClassName={this.makeClassName("yThumb")}
					thumbStyle={_.extend(this.props.yThumbStyle, cursorStyle)}
					minThumbSize={this.props.minYThumbSize}
					useGlobalHotkeys={this.props.useGlobalHotkeysForY}
					onChange={delta => this.handleBarChange(0, delta)}
					onKeySpecial={code => this.props.onKeySpecial("y", code)}
				/>
			) : null;

		const content = (
			<ScrollContent
				className={this.makeClassName("content")}
				style={this.props.contentStyle}
			>
				{this.props.children}
			</ScrollContent>
		);

		const posStyle = _.extend({}, this.props.posStyle, {
			willChange: "transform", // CPV performance optimization to reduce cost of transform: translate. necessary for Safari
			transform:
				"translateZ(0) translate(" +
				Math.round(-this.state.xPos) +
				"px, " +
				Math.round(-this.state.yPos) +
				"px)",
			// Support Safari 8
			WebkitTransform:
				"translateZ(0) translate(" +
				Math.round(-this.state.xPos) +
				"px, " +
				Math.round(-this.state.yPos) +
				"px)",
		});

		let fadeEls = [];
		if (!this.props.noFade) {
			fadeEls = [
				this.renderFadeX(-1),
				this.renderFadeX(1),
				this.renderFadeY(-1),
				this.renderFadeY(1),
			];
		}

		// Order of scrollbar and fade determines whether scrollbar fades or not.
		// TODO: decide which we want.
		return (
			<div
				ref={ref => (this.areaDiv = ref)}
				className={this.makeClassName("area")}
				style={this.props.areaStyle}
			>
				<div
					ref={ref => (this.contentDiv = ref)}
					className={this.makeClassName("pos")}
					style={posStyle}
				>
					{content}
				</div>
				{scrollbarX}
				{scrollbarY}
				{fadeEls}
			</div>
		);
	},
});
